import { JSX, FC } from "react";
import { Button } from "antd";
import InfoCard from "components/ui/InfoCard/InfoCard";

interface IInfoNotificationProps {
  handleOpenModal: () => void;
}

const InfoNotification: FC<IInfoNotificationProps> = ({
  handleOpenModal
}): JSX.Element => {
  return (
    <InfoCard
      text={{
        content: `По правилам ЭТП, артикул товара должен быть уникальным в рамках каталога одного продавца.
                Рекомендуем перед загрузкой проверить артикулы и актуальность данных.`
      }}
      actionBtn={
        <Button
          type="link"
          size="large"
          onClick={handleOpenModal}
        >
          Подробнее
        </Button>
      }
      icon={{ type: "exclamation", className: "flex-shrink-0 mr-2" }}
      className="!mb-0 !px-4"
    />
  );
};

export default InfoNotification;